import {
  GetEmployeeQueryVariables,
  useGetEmployeeLazyQuery,
  useGetUserOrganizationQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetOrganization() {
  const { data, loading, error } = useGetUserOrganizationQuery({
    fetchPolicy: "cache-first",
  });

  const organization = useMemo(() => {
    return (data && data.getUserOrganization) || null;
  }, [data]);

  return { data: organization, loading, error } as const;
}
